<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
            <b-row>
                <b-col md="4">
                    <strong>Jenis Barang :</strong>
                    <multiselect v-model="selectedItemKind" label="name" track-by="id" :internal-search="true"
                        :options="optItemKind" @input="onChangeSelected" />
                </b-col>
            </b-row>
            <b-card v-if="items" class="mt-3">
                <h5 class="mb-0">{{ items || "-" }}</h5>
                <hr />
                <b-row class="mb-3">
                    <b-col md="6">
                        <div class="small text-muted">
                            Perubahan terakhir pada {{ $helper.parseDate(lastUpdatedAt) }}<br />
                            oleh {{ lastUpdatedBy }}
                        </div>
                    </b-col>
                    <b-col md="6" class="text-right">
                        <b-button variant="dark" @click="addRow(-1)">
                            <i class="fa fa-plus mr-2"></i> Tambah Baris Paling Atas
                        </b-button>
                    </b-col>
                </b-row>
                <b-table responsive bordered no-local-sorting :fields="fields" :items="entries"
                    @sort-changed="onSortChanged">
                    <template v-slot:cell(from)="row">
                        <b-form-input v-model="row.item.from" class="text-right"
                            @input="sanitize(row.item, 'from')"></b-form-input>
                    </template>
                    <template v-slot:cell(to)="row">
                        <b-form-input v-model="row.item.to" class="text-right"
                            @input="sanitize(row.item, 'to')"></b-form-input>
                    </template>
                    <template v-slot:cell(b)="row">
                        <b-form-input v-model="row.item.b" class="text-right"
                            @input="sanitize(row.item, 'b')"></b-form-input>
                    </template>
                    <template v-slot:cell(c)="row">
                        <b-form-input v-model="row.item.c" class="text-right"
                            @input="sanitize(row.item, 'c')"></b-form-input>
                    </template>
                    <!-- <template v-slot:cell(d)="row">
                        <b-form-input v-model="row.item.d" class="text-right" @input="sanitize(row.item, 'd')"></b-form-input>
                    </template> -->
                    <template v-slot:cell(action)="row">
                        <div style="width: 80px; margin-top: 2px">
                            <b-button size="sm" variant="primary" class="mr-2" v-b-tooltip.hover title="Tambah"
                                @click="addRow(row.index)">
                                <i class="fa fa-plus"></i>
                            </b-button>
                            <b-button size="sm" variant="danger" v-b-tooltip.hover title="Hapus"
                                @click="deleteRow(row.index)">
                                <i class="fa fa-times"></i>
                            </b-button>
                        </div>
                    </template>
                </b-table>
                <div class="text-right mt-3">
                    <b-button variant="success" @click="confirmSave">
                        Simpan Perubahan
                    </b-button>
                </div>
            </b-card>
        </div>
        <b-modal id="m-confirm" title="Simpan Perubahan" no-close-on-backdrop no-close-on-esc hide-footer>
            Simpan rumus umum grade untuk barang <strong>{{ items }}</strong>?
            <div class="small text-muted">Harga 'sampai' terakhir akan otomatis diubah menjadi 99 miliar ketika disimpan.
            </div>
            <div class="text-right mt-4">
                <b-button variant="primary" @click="execSave" :disabled="isSubmitting">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'rumus-umum-grade',
    data() {
        return {

            initStatus: 0,
            isSubmitting: false,
            isFetching: false,

            mode: 1, // 1: HP, 2: Non-HP
            activeItems: [],

            fields: [
                { key: "from", label: "Dari", sortable: true },
                { key: "to", label: "Sampai", sortable: true },
                { key: "b", label: "Grade B", sortable: true },
                { key: "c", label: "Grade C", sortable: true },
                // { key: "d", label: "Grade X"},
                { key: "action", label: "Aksi" }
            ],

            inputs: ["from", "to", "b", "c"],

            itemsHp: [],
            itemsNonHp: [],

            hpLastUpdated: { at: "", by: "" },
            nonHpLastUpdated: { at: "", by: "" },

            sortBy: null,
            sortDesc: false,

            optItemKind: [],
            selectedItemKind: null,

            items: null,
            entries: [],
            lastUpdatedAt: "",
            lastUpdatedBy: ""



        }
    },
    methods: {

        init() {

            this.initStatus = 0
            this.getItems()
            this.getItemKinds()

        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
            this.getItemKinds()
        },

        getItems() {

            let param = ""

            if (this.selectedItemKind != null) {
                param += "?itemKindId=" + this.selectedItemKind.id
            }

            if (!this.$helper.isBlank(this.sortBy)) {
                param += "&sortBy=" + this.sortBy
                param += "&sortDesc=" + this.sortDesc
            }

            this.initStatus = 0
            this.$axios.get("/master/grade-price-adjustment" + param).then(res => {

                let data = res.data.data
                this.items = data.items
                this.entries = data.entries
                this.lastUpdatedAt = data.lastUpdatedAt
                this.lastUpdatedBy = data.lastUpdatedBy
                this.sanitizeAll()


                this.initStatus = 1

            })
                .catch(error => {
                    console.log(error)
                    this.initStatus = -1
                })

        },

        confirmSave() {

            if (this.entries[0].from != "0") {
                return this.$helper.toastError(this, "Baris pertama harus dimulai dengan dari Rp 0!")
            }

            for (var i = 0; i < this.entries.length; i++) {
                for (var j = 0; j < this.inputs.length; j++) {
                    if (this.entries[i][this.inputs[j]] == "") {
                        return this.$helper.toastError(this, "Terdapat kotak yang kosong, mohon cek kembali!")
                    }
                }
            }

            this.$bvModal.show("m-confirm")

        },

        execSave() {

            let entriesData = []
            this.entries.forEach(it => {
                entriesData.push({
                    from: this.$helper.toNumber(it.from),
                    to: this.$helper.toNumber(it.to),
                    b: this.$helper.toNumber(it.b),
                    c: this.$helper.toNumber(it.c),
                    // d: this.$helper.toNumber(it.d)
                })
            })

            let payload = {
                itemKindId: this.selectedItemKind.id,
                entries: entriesData
            }

            this.isSubmitting = true
            this.$axios.post("/master/grade-price-adjustment", payload).then(res => {

                this.getItems()

                this.entries[this.entries.length - 1].to = "99.999.999.999"

                this.$bvModal.hide("m-confirm")
                this.$helper.toastSuccess(this, "Rumus umum untuk " + this.items + " berhasil disimpan!")

            })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => this.isSubmitting = false)

        },

        addRow(index) {
            this.entries.splice(index + 1, 0, { from: "", to: "", b: "", c: "" })
        },

        deleteRow(index) {
            this.entries.splice(index, 1)
        },

        switchMode(newMode) {

            if (this.mode == 1 && newMode == 2) {
                this.mode = 2
                this.activeItems = this.itemsNonHp
            }
            else if (this.mode == 2 && newMode == 1) {
                this.mode = 1
                this.activeItems = this.itemsHp
            }

        },

        sanitize(item, varName) {

            let cleaned = String(item[varName]).replace(/\./g, "")
            let res = cleaned.replace(/(?!^-)[^0-9]/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            item[varName] = res

        },

        sanitizeAll() {
            this.entries.forEach(it => {
                this.inputs.forEach(v => this.sanitize(it, v))
            })
        },

        getItemKinds() {

            let getItemKinds = this.$axios.get("master/kinds").then(res => {
                this.optItemKind = res.data.data.map(it => {
                    return {
                        name: it.name,
                        id: it.id
                    }
                })
                this.selectedItemKind = this.optItemKind[0]
            })

            Promise.all([getItemKinds]).then(() => {
                this.getItems()
            })
                .catch(_ => {
                    this.initStatus = -1
                })
        },

        onChangeSelected() {
            this.getItems()
        }
    },

    created() {
        this.init()
    },

    // watch: {
    //     selectedItemKind() {
    //         this.initStatus = 0
    //         this.getItems()
    //     }
    // }
}
</script>
